import jQuery from "jquery";

jQuery(function () {
  jQuery("a[disabled]").click(function () {
    return false;
  });
});
